import './Filter.scss';
import '../Messages/Messages.scss';
import React, { useState } from 'react';
import { useQuery } from '@apollo/client/react';
import { useStoreContext } from '../App/StoreProvider';
import {
    GET_ALL_LOFAS_BY_JOB,
    GET_ALL_DRIVERS_FILTER,
    GET_ALL_CARRIERS_FILTER,
    GET_ALL_PROPPANTS_BY_JOB,
    GET_ALL_STATUS_FILTER,
    GET_LOADS_CSV,
} from '../../graphql/client/queries';
import {
    GetAllLofasByJob,
    GetAllDriversFilter,
    GetAllCarriersFilter,
    GetAllProppantsByJob,
    GetAllStatusFilter,
    GetLoadListCSV,
} from '../../types/schemaTypes';
import { Error, Loading } from '../_common';
import LoadFilterItem from './FilterItem/LoadFilterItem';
import Button from 'react-bootstrap/Button';
import { Base64 } from 'js-base64';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface JobLoadsFiltersProps {
    abortRequest: () => void;
    jobId: number;
    onFilterToggle: () => void;
    showFilter: boolean;
    setShowFilter: React.Dispatch<React.SetStateAction<boolean>>;
    dateRangeFilter?: string | null;
}

export const JobLoadsFilters = ({
    abortRequest,
    jobId,
    onFilterToggle,
    showFilter,
    setShowFilter,
    dateRangeFilter = '1week',
}: JobLoadsFiltersProps): React.ReactElement => {
    const [activeKey, setActiveKey] = useState('0');

    const [state] = useStoreContext();
    let statuses: any[] = [];
    const proppants: any[] = [];
    const lofaFilters: any[] = [];
    let driverFilters: any[] = [];
    let carrierFilters: any[] = [];
    const variables = {
        jobId,
    };
    const {
        loadList: {
            searchPhraseSubset: { statusSubset, proppantSubset, lofaSubset, driverSubset, carrierSubset },
        },
    } = state;

    const { data: proppantsData, loading: proppantLoading, error: proppantError } = useQuery<GetAllProppantsByJob>(GET_ALL_PROPPANTS_BY_JOB, {
        variables,
    });
    const { data: lofasData } = useQuery<GetAllLofasByJob>(GET_ALL_LOFAS_BY_JOB, { variables });
    const { data: driversData } = useQuery<GetAllDriversFilter>(GET_ALL_DRIVERS_FILTER);
    const { data: carriersData } = useQuery<GetAllCarriersFilter>(GET_ALL_CARRIERS_FILTER);
    const { data: loadStatusesData } = useQuery<GetAllStatusFilter>(GET_ALL_STATUS_FILTER);

    const { data: csvExport } = useQuery<GetLoadListCSV>(GET_LOADS_CSV, {
        variables: {
            input: {
                jobId,
                dateRangeFilter,
            },
        },
    });

    if (proppantLoading) {
        return <Loading />;
    }
    if (proppantError) {
        return <Error error={proppantError} />;
    }

    if (lofasData && lofasData.getAllLofasByJob) {
        lofasData.getAllLofasByJob.forEach((item: any) => {
            lofaFilters.push({
                id: item.lofaId,
                name: item.lofaName,
            });
        });
    }

    if (driversData && driversData.getAllDriversFilter) {
        driverFilters = driversData.getAllDriversFilter;
    }

    if (carriersData && carriersData.getAllCarriersFilter) {
        carrierFilters = carriersData.getAllCarriersFilter;
    }

    if (proppantsData && proppantsData.getAllProppantsByJob) {
        proppantsData.getAllProppantsByJob.forEach((item: any) => {
            proppants.push({
                id: item.proppantId,
                name: item.proppantName,
            });
        });
    }

    if (loadStatusesData && loadStatusesData.getAllStatusFilter) {
        statuses = loadStatusesData.getAllStatusFilter;
        // Remove the UNKNOWN status from the statuses list
        statuses = statuses.filter(stat => {
            // if (stat.name == 'Created') {const data ={...stat}; data.name = 'Created/Rejected'; stat= {...data};}//stat.name = 'Created/Rejected';
            return stat.name !== 'Unknown';
        });

        const copyLoadStatus : any = [];
        statuses.forEach((ele)=>{
            const copy = {...ele};
            if (copy?.name == 'Created'){
                copy.name = 'Created/Rejected'; 
            }
            copyLoadStatus.push(copy);
        });
        statuses = copyLoadStatus;
    }

    const getCurrentDate = (): string => {
        const today = new Date();

        const day = today.getDate();
        const month = today.getMonth() + 1;
        const year = today.getFullYear();

        const strDay = day < 10 ? `0${day}` : `${day}`;
        const strMonth = month < 10 ? `0${month}` : `${month}`;

        return `${year}${strMonth}${strDay}`;
    };

    const exportCsv = (): void => {
        const jobId = variables.jobId;

        if (csvExport?.getLoadListCSV?.csv) {
            const result = csvExport.getLoadListCSV.csv ?? '';
            const decodedCsv = Base64.decode(result);

            const file = new Blob([decodedCsv], { type: 'application/csv' });
            const url = window.URL.createObjectURL(file);
            const a = document.createElement('a');
            a.href = url;

            a.download = `List of Loads for Job ${jobId}_${getCurrentDate()}.csv`;
            a.click();
        }
    };

    return (
        <div
            id="MessagesFilterContainer"
            className={showFilter ? 'JobLoads-FiltersContainer' : 'JobLoads-FiltersContainer hide'}
        >
            <div className="Filter-Container">
                <div className="Filter-Header">
                    <div className="Filter-HeaderIconContainer">
                        <i className="material-icons">filter_list</i>
                        <span className="Filter-HeaderTitle">Filters</span>
                    </div>
                    <Button
                        className="Filter-SelectAll"
                        variant="link"
                        onClick={(): void => setActiveKey(activeKey === '0' ? '1' : '0')}
                    >
                        {activeKey === '0' ? 'Collapse All' : 'Expand All'}
                    </Button>
                    <FontAwesomeIcon
                        icon={['fas', 'times-circle']}
                        className="JobLoads-Filter"
                        onClick={() => setShowFilter(!showFilter)}
                    />
                </div>

                <div className="Filter-Body">
                    <LoadFilterItem
                        abortRequest={abortRequest}
                        title="Status"
                        items={statuses}
                        itemsSubset={statusSubset.subset}
                        searchPhrase={statusSubset.searchPhrase}
                        activeKey={activeKey}
                        isCollection={true}
                        isSearchable={false}
                        onFilterToggle={onFilterToggle}
                    />
                    <LoadFilterItem
                        abortRequest={abortRequest}
                        title="Proppant"
                        items={proppants}
                        itemsSubset={proppantSubset.subset}
                        searchPhrase={proppantSubset.searchPhrase}
                        activeKey={activeKey}
                        isCollection={true}
                        isSearchable={true}
                        onFilterToggle={onFilterToggle}
                    />
                    <LoadFilterItem
                        abortRequest={abortRequest}
                        title="Loading Facility"
                        items={lofaFilters}
                        itemsSubset={lofaSubset.subset}
                        searchPhrase={lofaSubset.searchPhrase}
                        activeKey={activeKey}
                        isCollection={true}
                        isSearchable={true}
                        onFilterToggle={onFilterToggle}
                    />
                    <LoadFilterItem
                        abortRequest={abortRequest}
                        title="Driver"
                        items={driverFilters}
                        itemsSubset={driverSubset.subset}
                        searchPhrase={driverSubset.searchPhrase}
                        activeKey={activeKey}
                        isCollection={true}
                        isSearchable={true}
                        onFilterToggle={onFilterToggle}
                    />
                    <LoadFilterItem
                        abortRequest={abortRequest}
                        title="Carrier"
                        items={carrierFilters}
                        itemsSubset={carrierSubset.subset}
                        searchPhrase={carrierSubset.searchPhrase}
                        activeKey={activeKey}
                        isCollection={true}
                        isSearchable={true}
                        onFilterToggle={onFilterToggle}
                    />
                    <div className="Filter-Download-Container">
                        <i className="material-icons Filter-Download-Icon">get_app</i>
                        <Button
                            className="Filter-SelectAll"
                            variant="link"
                            onClick={(): void => {
                                exportCsv();
                            }}
                        >
                            Download CSV
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};
